import { lazy, Suspense, type FC } from "react";
import type { CodeEditorProps } from "./codeEditor.js";

// CodeMirror is heavy and only a few fields need it, so it loads on demand.
const CodeEditor = lazy(() =>
  import("./codeEditor.js").then((module) => ({
    default: module.CodeEditor,
  })),
);

/** The code editor, with a placeholder its size while it loads. */
export const LazyCodeEditor: FC<CodeEditorProps> = (props) => {
  const { minHeight } = props;

  return (
    <Suspense
      fallback={
        <div
          className="rounded-md bg-gray-50 ring-1 ring-border-strong ring-inset"
          // The editable area plus the editor's 1px borders.
          style={{ height: minHeight + 2 }}
        />
      }
    >
      <CodeEditor {...props} />
    </Suspense>
  );
};
